import { Share2, Link2, Mail, Facebook, Twitter, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";

export function ShareMenu({ shareUrl, shareText }) {
  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: shareText, text: shareText, url: shareUrl }); } catch (e) { /* user dismissed the native share sheet — not an error */ }
      return true;
    }
    return false;
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  const shareTo = (network) => {
    const u = encodeURIComponent(shareUrl);
    const t = encodeURIComponent(shareText);
    const urls = {
      whatsapp: `https://wa.me/?text=${t}%20${u}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      x: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
      email: `mailto:?subject=${t}&body=${t}%0A%0A${u}`,
    };
    window.open(urls[network], "_blank", "noopener,noreferrer");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" data-testid="share-button" className="w-full text-slate-600">
          <Share2 size={16} className="mr-2" /> Share
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="w-56">
        {typeof navigator !== "undefined" && navigator.share && (
          <DropdownMenuItem data-testid="share-native" onClick={nativeShare}><Share2 size={16} className="mr-2 text-emerald-600" /> Share via…</DropdownMenuItem>
        )}
        <DropdownMenuItem data-testid="share-whatsapp" onClick={() => shareTo("whatsapp")}><MessageSquare size={16} className="mr-2 text-emerald-600" /> WhatsApp</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-facebook" onClick={() => shareTo("facebook")}><Facebook size={16} className="mr-2 text-blue-600" /> Facebook</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-x" onClick={() => shareTo("x")}><Twitter size={16} className="mr-2 text-slate-900" /> X (Twitter)</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-email" onClick={() => shareTo("email")}><Mail size={16} className="mr-2 text-slate-500" /> Email</DropdownMenuItem>
        <DropdownMenuItem data-testid="share-copy" onClick={copyLink}><Link2 size={16} className="mr-2 text-slate-500" /> Copy link</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
